import { t } from "i18next";
import { Decryption } from "src_typescript_appice-core/dist/utils/security/decryption";

export function generateStrongRandomString(length: number) {
  let result = "";
  const characters =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$%&";
  const charactersLength = characters.length;

  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * charactersLength);
    result += characters.charAt(randomIndex);
  }

  return result;
}
export function copyText(value: string) {
 return navigator.clipboard
    .writeText(value)
    .then(() => {
      return { success: true, message: t("copiedMsg") };
    })
    .catch((err) => {
      return { success: false, message: t("somethingWrongLabel") };
    });
}
export function textOverflowThreeDot(value:string,maxChar:number){
  return value?.length>maxChar?value?.slice(0,maxChar-3)+"...":value
 }
export async function processString(str: string, token: string): Promise<string> {
  const enc = new Decryption('', '');

  // Derive key from token using Decryption class's sha256 method
  // This matches backend's decryptWithRandomIV: sha256(this.key).then(hash => hash.substring(0, 32))
  const hash = await enc.sha256(token);
  const keyString = hash.substring(0, 32);

  // Generate random IV (hex) - 32 hex chars = 16 bytes
  const iv = enc.generateRandomIV16();

  // Encrypt - returns base64 encoded ciphertext
  const cipher = await enc.encrypt(str, keyString, iv);

  // Return IV (hex) + ciphertext (base64) - matches backend's expected format
  return iv + cipher;
}
